import { request } from 'Lib/axios'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'

const postAcceptOffer = async () => {
  const { accountId } = useUserStore.getState()

  return await request({
    url: `accounts-migration/${accountId}/accept-offer`,
    method: 'POST',
  })
}

export const useAcceptOffer = () => {
  const queryClient = useQueryClient()
  return useMutation(postAcceptOffer, {
    onSuccess: () => {
      // Refetch the entire app, after accepting the offer
      void queryClient.refetchQueries()
    },
  })
}
